// Local SVGs shared by the bookmark popover and the bookmark editor
// modal. Inlined (rather than pulled from the app-wide icon set) because
// they're tiny, only used by these two surfaces, and keeping them
// adjacent makes the bookmark code easier to read end-to-end.

export const BookmarkIcon = ({
  filled = false,
  className
}: {
  filled?: boolean
  className?: string
}) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill={filled ? 'currentColor' : 'none'}
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M3.33333 2.66667C3.33333 2.29848 3.63181 2 4 2H12C12.3682 2 12.6667 2.29848 12.6667 2.66667V14L8 11.3333L3.33333 14V2.66667Z'
      stroke='currentColor'
      strokeWidth='1.4'
      strokeLinejoin='round'
    />
  </svg>
)

export const PlusIcon = () => (
  <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M7 3v8M3 7h8' stroke='currentColor' strokeWidth='1.6' strokeLinecap='round' />
  </svg>
)

export const SearchIcon = () => (
  <svg width='14' height='14' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='7' cy='7' r='4.5' stroke='currentColor' strokeWidth='1.4' />
    <path d='M10.5 10.5L13.5 13.5' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' />
  </svg>
)

export const EditIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.5 12.5l2.9-.58 6.35-6.35a1.55 1.55 0 000-2.19l-.13-.13a1.55 1.55 0 00-2.19 0L4.08 9.6 3.5 12.5z'
      stroke='currentColor'
      strokeWidth='1.35'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const DeleteIcon = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M3 4.5h10' stroke='currentColor' strokeWidth='1.35' strokeLinecap='round' />
    <path
      d='M6.25 4.5V3.25h3.5V4.5'
      stroke='currentColor'
      strokeWidth='1.35'
      strokeLinejoin='round'
    />
    <path
      d='M4.25 4.5l.55 8.25A1.35 1.35 0 006.15 14h3.7a1.35 1.35 0 001.35-1.25l.55-8.25'
      stroke='currentColor'
      strokeWidth='1.35'
      strokeLinejoin='round'
    />
    <path d='M6.75 7v4M9.25 7v4' stroke='currentColor' strokeWidth='1.35' strokeLinecap='round' />
  </svg>
)

export const LockIcon = () => (
  <svg width='14' height='14' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M4.5 7V5a3.5 3.5 0 117 0v2M3.5 7h9v6.5a1 1 0 01-1 1h-7a1 1 0 01-1-1V7z'
      stroke='currentColor'
      strokeWidth='1.4'
      strokeLinejoin='round'
    />
  </svg>
)

export const PeopleIcon = () => (
  <svg width='14' height='14' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.5 8a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM10.5 8.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM2 13c0-1.93 1.57-3.5 3.5-3.5S9 11.07 9 13M9.75 13c0-1.13.62-2.12 1.55-2.65a3 3 0 014.7 2.45'
      stroke='currentColor'
      strokeWidth='1.4'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
